import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, SvgIcon } from '@mui/material';
import { palette, spaces } from '../../../assets/styles/themes/tokens';
import CreateNewCollection from './CreateNewCollection';
import { ManageItemInCollectionContext } from '../../../state/ManageItemInCollectionProvider';
import getMuiIcon from '../../../utils/getMuiIcon';
import OnboardingOptionItem from '../../onboarding/OnboardingOptionItem';
import CustomDialog from '../../Dialog/CustomDialog';

interface AddToCollectionModalProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  title?: string;
  children?: React.ReactNode;
  onSetNewCollectionId: (collectionId: string) => void;
}

const AddToCollectionModal: React.FC<AddToCollectionModalProps> = ({
  open,
  onClose,
  onSave,
  onSetNewCollectionId,
}) => {
  const { t } = useTranslation();
  const {
    collections,
    toggleCollection,
    itemBelongsToAtLeastOneCollection,
  } = useContext(ManageItemInCollectionContext);

  const DialogContent = () => {
    return (
      <Box 
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: spaces.md,
        }}
      >
        {!itemBelongsToAtLeastOneCollection && (
          <CreateNewCollection onSetNewCollectionId={onSetNewCollectionId} />
        )}
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: spaces.md,
        }}>
          {collections.map((collection) => (
            <OnboardingOptionItem 
              key={collection.id} 
              avatar={<SvgIcon component={getMuiIcon('collectionsFolder')} sx={{ fill: palette.text.primary }} />} 
              label={collection.title}
              isSelected={collection.containsItem}
              onClick={() => toggleCollection(collection.id)}
            />
          ))}
        </Box>
      </Box>
    );
  };

  return (
    <CustomDialog
      dataTestId='add-to-collection-dialog'
      open={open}
      onClose={onClose}
      title={t('Manage collection content')}
      primaryButton={{ label: t('Save'), onClick: onSave }}
      secondaryButton={{ label: t('Cancel'), onClick: onClose }}
    >
      <DialogContent />
    </CustomDialog>
  );
};

export default AddToCollectionModal;
